module.exports = __webpack_public_path__ + "img/mession.e1629ae5.jpg";